export default __webpack_public_path__ + "static/media/cert-E-commerce-consumer.989dfc3a.jpg";